import Validate from './Validate.js';
import { analyticsSuccessForm } from './Analytics';
import { analyticsFieldFocus } from './Analytics';
import { analyticsClickEvent } from './Analytics';
import { analyticsCheckboxFocus } from './Analytics';

const fileArrayWords = ['файл', 'файла', 'файлов'];

const $closeFormBtn = $('.js-close-form-btn');
const $feedbackForm = $('.js-feedback-form');
const $openForm = $('.js-open-form');

$closeFormBtn.on('click', function () {
    $feedbackForm.removeClass('_open');
    setTimeout(function () {
        resetForm($feedbackForm.find('.js-form'));
    }, 500);

});

$openForm.on('click', function () {
    $feedbackForm.addClass('_open');
    analyticsClickEvent($openForm);
});


function initForm() {

    // Валидация и отправка формы
    App.H.find('.js-validate-form').each(function() {
        const $form = $(this);
        const $btn = $form.find('.js-submit');
        const $ajaxError = $form.find('.js-ajax-error');
        const $staticAjaxError = $form.find('.js-static-ajax-error');

        // Валидация
        new Validate(this);

        // Отправка
        $form.on('submit', function(e) {
            e.preventDefault();

            if ($form.find('input._error, input._notvalidated').length > 0) {
                $form.find('input._notvalidated').addClass('_error');
                $form.find('.js-form-error').addClass('_visible');
                return false;
            } else {
                $form.find('.js-form-error').removeClass('_visible');
            }

            // Отправляем форму
            $form.ajaxSubmit({
                url: $form.attr('action'),
                dataType: 'json',
                type: $form.attr('method'),
                cache: false,
                success: (response) => {
                    if (!response.success) {
                        // Ошибка на сервере
                        $form.removeClass('_success').addClass('_error');
                        $form.find('.js-form-content').slideUp();
                        $form.find('.js-form-fail').slideDown();

                        console.log(response);

                    } else {
                        // Успех!
                        if (response.success) {
                            $ajaxError.html('');
                            $staticAjaxError.fadeOut();
                            $form.find('.js-form-content').slideUp();
                            $form.find('.js-form-success').slideDown();
                            $form.removeClass('_error').addClass('_success');
                            $form.find('.js-upload').val('').change();
                            analyticsSuccessForm();

                          console.log(response);
                        }
                    }
                },
                error: (response) => {
                    // Ошибка отправки
                    $ajaxError.html($ajaxError.data('server-error'));

                  console.log(response);

                    $btn.removeAttr('disabled');
                }
            });
        });
    });



    // Открытие и закрытие формы
    {
        App.H.find('.js-form-ok').off('click').on('click', function(e) {
            e.preventDefault();
            $(this).closest('.js-form').removeClass('_success _error');
        });
    }



    // Загрузка файла
    App.H.on('change', '.js-upload', function() {
        const $input = $(this);
        const $label = $input.siblings('.js-upload-label');
        const val = $input.val();
        let fileName;

        if (val.length) {
            fileName = val.split('\\').pop() || '';
            $label.text(fileName);
            $input.addClass('_active');
        } else {
            $label.text( $label.data('text') );
            $input.removeClass('_active');
        }
    });


    App.H.on('click', '.js-upload-clear', function() {
        $(this).siblings('.js-upload').val('').change();
    });



    // Антиспам
    (function() {
        // return;
        let seconds = 0;

        // Проверка phantomJS
        let isBot = function() {
            var retval = false;

            if (window._phantom || window.callPhantom) retval = true;
            if (window.__phantomas) retval = true; //PhantomJS-based web perf metrics + monitoring tool
            if (window.Buffer) retval = true; //nodejs
            if (window.emit) retval = true; //couchjs
            if (window.spawn) retval = true;  //rhino
            if (window.webdriver) retval = true; //selenium
            if (window.domAutomation || window.domAutomationController) retval = true; //chromium based automation driver
            // if (window.outerWidth === 0 && window.outerHeight === 0) retval = true; //headless browser

            return retval;
        };

        if (isBot()) {
            return false;
        }


        // Считаем, сколько времени пользователь провёл на сайте, и отправляем это в форме
        $('.js-validate-form').each(function () {
            let name = $(this).data('name');
            $(this).append(`<input type="hidden" name="${name}" class="js-input-seconds" value="0" />`);
        });

        clearInterval(App.antispamTimeout);
        App.antispamTimeout = setInterval(() => {
            seconds++;
            App.H.find('.js-input-seconds').val(seconds);
        }, 1000);
    })();



    // Фикс autocomplete="off" для IE и Edge
    if (App.ie || App.edge) {
        window.onbeforeunload = function() {
            $('form[autocomplete="off"]').each(function() {
                this.reset();
            });
        };
    }
}

initForm();



export function resetForm(_form) {
    _form[0].reset();
    _form.find(':checkbox[data-required]').prop('checked', true);
    _form.removeClass('_success _error');
    _form.find('[data-required]').not(':checkbox').addClass('_notvalidated').val('');
    _form.find('[data-required-group]').addClass('_notvalidated');
    _form.find('._focused input').each(function() {
        if ( !$(this).val().length ) {
            $(this).closest('.js-input-wrap').removeClass('_focused');
        } else {
            $(this).removeClass('_notvalidated');
        }
    });

    _form.find('.js-form-content').show();
    _form.find('.js-form-success').hide();
    _form.find('.js-form-fail').hide();

    _form.find('._error').removeClass('_error');
}

$('.js-form input[type="checkbox"], .js-form input[type="radio"]').on('focus', function() {
    let $currbtn = $(this);
    let _type = $currbtn.attr('type') === 'checkbox' ? 'i_want' : 'my_budget';

    analyticsCheckboxFocus($currbtn, _type);
});

//App.H.on('focus', '.js-upload, input.js-input, textarea.js-input', function() {
$('.js-upload, input.js-input, textarea.js-input').on('focus', function() {
    analyticsFieldFocus($(this));
});

// Подсказка сдвигается вверх при заполненном поле
App.H.on('input', 'input.js-input, textarea.js-input', function() {
    const val = $.trim($(this).val());

    if (!val.length) {
        $(this).closest('.js-input-wrap').removeClass('_focused');
    } else {
        $(this).closest('.js-input-wrap').addClass('_focused');
    }
});

/* при выборе файлов запускаем проверку на размер и кол-во файлов */
App.H.on('change', '.js-upload-file-input', function(e) {
    let files = e.originalEvent.target.files;

    chooseFiles(files, $(this));
});

App.H.on('click', '.js-ok-btn', function(e) {
    let $thisForm = $(this).closest('.js-validate-form');
    resetForm($thisForm);
    e.preventDefault();
});

/* Проверяет не превышен ли лимит на файлы и их размер и выводит соответствующее соощение */
function chooseFiles (files, fileInput) {
    let files_size = 0;
    let fileInputLabel = fileInput.parent().siblings('.js-upload-files-label');

    $.each(files, function(index, el) {
        files_size += el.size;
    });

    if (files.length === 0) {
        fileInputLabel.removeClass('_no-empty _error').html(fileInputLabel.data('default'));
    } else if((files_size / 1000000 > parseInt(fileInput.data('max-size'))) || (files.length > parseInt(fileInput.data('max-count')))) {
        let error_text = fileInput.data('error');

        error_text = error_text.replace('count', fileInput.data('max-count'));
        error_text = error_text.replace('size', fileInput.data('max-size'));
        fileInputLabel.addClass('_no-empty _error').html(error_text);
    } else {
        fileInputLabel.removeClass('_error').addClass('_no-empty').html(`Вы прикрепили ${files.length} ${getWord(files.length, fileArrayWords)}`);
    }
}

/* Возвращает слово в нужном склонения в зависимости от числительного */
function getWord(number, _array) {
    let keys = [2, 0, 1, 1, 1, 2];
    let mod = number % 100;
    let suffixKey = (mod > 7 && mod < 20) ? 2: keys[Math.min(mod % 10, 5)];

    return _array[suffixKey];
}



// WEBPACK FOOTER //
// ./_src/js/modules/Form.js